<template>
  <div id="app">
    <div class="row mx-1">
      <div class="col-12 mb-3">
        <list-filters @filter="filter($event)" />
      </div>
      <div class="col-12">
        <div class="card" :class="{ 'card-versionMovil': !$store.state.responsive.viewDesktopLists}">
          <div class="card-body pb-0">
            <div class="align-items-center d-flex justify-content-between mb-1">
              <p class="mb-2">
                Mostrando {{ from }}-{{ to }} de {{ totalItems }} productos
              </p>
              <a href="#" class="mb-2" @click="openProductModal()" v-if="$store.state.roles.Backoffice_member_empresas">
                <v-icon name="la-shopping-cart-solid" scale="1.4" /> Ver productos añadidos
              </a>
            </div>
            <list :products="products" @selectOrder="selectOrder($event)" />
            <div class="row">
              <div class="col-12 col-sm-8 col-lg-5">
                <div class="form-group" v-if="numberPages > 1">
                  <div class="float-left mr-3 mt-2">
                    <select v-model="itemsPerPage" class="form-control" id="itemsPerPage"
                            @change="changeItemsPerPage()">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <label for="itemsPerPage" class="col-form-label mt-2">Productos por página</label>
                </div>
              </div>
              <div class="col-12 col-sm-4 col-lg-7" v-if="numberPages > 1">
                <pagination :currentPage=currentPage :numberPages=numberPages @selectPage="selectPage($event)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <SelectedProducts
      :id="'selectedProducts'"
      :modalTitle="'PRODUCTOS AÑADIDOS'"
      :class="'modal-lg'"
      :showFooter="false"
      :tab=1
      v-if="modalProducts"
      @closeModal="modalProducts = false"
  />
</template>

<script>
import axios from "axios";
import List from "./templates/List.vue";
import ListFilters from "@/components/Widgets/Shared/ProductListFilters.vue";
import Pagination from "@/components/Widgets/Shared/Pagination.vue";
import SelectedProducts from "../SelectedProducts/SelectedProducts.vue";
import { Modal as ModalBootstrap } from "bootstrap";
export default {
  name: "App",
  data() {
    return {
      modalProducts: false,
      brand: "",

      model: "",
      capacity: "",
      color: "",
      stock: "",
      priceTo: "",
      priceFrom: "",
      products: [],
      filters: "",
      itemsPerPage: 25,
      currentPage: 0,
      totalItems: 0,
      numberPages: 0,
      from: 0,
      to: 0,
      order: "",
    };
  },
  components: {
    List,
    ListFilters,
    Pagination,
    SelectedProducts,
  },
  created() {
    this.loadProducts();
  },
  methods: {
    filter(value) {
      this.brand = value.brand !== undefined ? value.brand : this.brand;
      this.model = value.model !== undefined ? value.model : this.model;
      this.capacity = value.capacity !== undefined ? value.capacity : this.v;
      this.color = value.color !== undefined ? value.color : this.color;
      this.stock = value.stock !== undefined ? value.stock : this.stock;
      this.priceFrom =
          value.priceFrom !== undefined ? value.priceFrom : this.priceFrom;
      this.priceTo = value.priceTo !== undefined ? value.priceTo : this.priceTo;
      this.currentPage = 0;

      this.loadProducts();
    },
    filterBrand() {
      if (this.brand !== "" && this.brand !== undefined) {
        this.filters = `${this.filters}brand=${encodeURIComponent(
            this.brand
        )}&`;
      }
    },
    filterModel() {
      if (this.model !== "" && this.model !== undefined) {
        this.filters = `${this.filters}model=${encodeURIComponent(
            this.model
        )}&`;
      }
    },
    filterColor() {
      if (this.color !== "" && this.color !== undefined) {
        this.filters = `${this.filters}color=${this.color}&`;
      }
    },
    filterCapacity() {
      if (this.capacity !== "" && this.capacity !== undefined) {
        this.filters = `${this.filters}capacity=${this.capacity}&`;
      }
    },
    filterStock() {
      if (this.stock !== "" && this.stock !== undefined) {
        this.filters = `${this.filters}inStock=${this.stock}&`;
      }
    },
    filterPrice() {
      if (this.priceFrom !== "" && this.priceFrom !== undefined) {
        this.filters = `${this.filters}priceFrom=${this.priceFrom}&`;
      }
      if (this.priceTo !== "" && this.priceTo !== undefined) {
        this.filters = `${this.filters}priceTo=${this.priceTo}&`;
      }
    },
    filterPagination() {
      this.filters = `${this.filters}pagination.pageSize=${this.itemsPerPage}&`;
      this.filters = `${this.filters}pagination.page=${parseInt(
          this.currentPage + 1
      )}&`;
    },
    selectPage(value) {
      this.currentPage = value;
      this.loadProducts();
    },
    selectOrder(value) {
      console.log(value);
      //Rellenar con el order cuando sepamos el formato
    },
    changeItemsPerPage() {
      this.currentPage = 0;
      this.loadProducts();
    },
    loadProducts() {
      this.filters = "";
      this.filterBrand();
      this.filterModel();
      this.filterColor();
      this.filterCapacity();
      this.filterStock();
      this.filterPrice();
      this.filterPagination();

      if (this.filters !== "") {
        this.filters = `?${this.filters}`;
      }

      const vm = this;
      axios.get(`/products/search${this.filters}`).then((response) => {
        vm.products = response.data.products;
        vm.totalItems = response.data.pagination.totalElements;
        vm.filters = "";
        vm.numberPages =
            vm.totalItems % vm.itemsPerPage === 0
                ? vm.totalItems / vm.itemsPerPage
                : parseInt(vm.totalItems / vm.itemsPerPage, 10) + 1;

        vm.from = vm.currentPage * vm.itemsPerPage + 1;
        vm.to =
            vm.currentPage * vm.itemsPerPage + vm.itemsPerPage > vm.totalItems
                ? vm.totalItems
                : vm.currentPage * vm.itemsPerPage + vm.itemsPerPage;
      });
    },
    openProductModal() {
      this.modalProducts = true;
      this.$nextTick(() => {
        if (this.modalInstance) {
          this.modalInstance.dispose();
        }
        this.modalInstance = new ModalBootstrap(
            document.getElementById("selectedProducts")
        );
        this.modalInstance.show();
      });
    },
  },
};
</script>

<style lang="scss"></style>
